import { HttpService } from "../../../utils/DesigningHttpService.js";
import { type AgencyChoice } from "./agencyIdentityService.ts";

const http = new HttpService();

export async function salesAgentAgencies(): Promise<AgencyChoice[]> {
  return (await http.getasync("/catalog/sales-agent/agencies")).data;
}

